"use strict";
/**
* IBM Confidential
* OCO Source Materials
* IBM Business Platform: Dashboard
* (C) Copyright IBM Corp. 2020
* The source code for this program is not published or otherwise divested of its trade secrets,
* irrespective of what has been deposited with the U.S. Copyright Office
**/

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var mobx_react_1 = require("mobx-react");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

var ColorPickerComponent_1 = __importDefault(require("../colorPicker/ColorPickerComponent"));

require("./summaryFillColorComponent.scss");

var SummaryFillColor =
/** @class */
function (_super) {
  __extends(SummaryFillColor, _super);

  function SummaryFillColor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SummaryFillColor.prototype.render = function () {
    var _a = this.props,
        uiContext = _a.uiContext,
        conditionalFormatsModel = _a.conditionalFormatsModel;
    var fillColor = {
      fill: conditionalFormatsModel.getSummaryFillColor()
    };
    return react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      justifyContent: 'space-between',
      className: 'vis-cf-summary-fill-color-wrapper'
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: 'vis-cf-summary-fill-color-label'
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFormattingSummaryFillColor')
    })), react_1.default.createElement(ca_ui_toolkit_1.Label, {
      className: 'vis-summary-fill-color-name',
      label: conditionalFormatsModel.getSummaryFillColor()
    }), react_1.default.createElement(ColorPickerComponent_1.default, {
      className: 'vis-cf-color-picker',
      useSystemPalettes: true,
      onColorSelected: this._onColorSelected.bind(this),
      orientation: 'bottom',
      selectedColor: fillColor,
      uiContext: uiContext,
      colorPickerModel: conditionalFormatsModel.getColorPickerModel()
    }));
  };

  SummaryFillColor.prototype._onColorSelected = function (hexColor) {
    this.props.conditionalFormatsModel.setSummaryFillColor(hexColor);
  };

  return SummaryFillColor;
}(react_1.Component);

exports.default = mobx_react_1.observer(SummaryFillColor);
